import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { BgLoader, PageError, UiButton } from "../../ui";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

import { Helmet } from "react-helmet";
import { ReceiptTemplate } from '../../receipt'


export default function Receipt() {
  let navigate = useNavigate();
  let { id } = useParams();

  const [state, setState] = useState({});
  const [loader, showLoader] = useState(false);

  const [pstate, setTitle] = useOutletContext(); 



  const downloadPdf = (id,id1) => {
    showLoader(true)
    fetch('https://api.practive.in/pdf?voucher=receipt&id='+id+':'+encodeURIComponent(id1)).then(response => {
        response.blob().then(blob => {
        
            const fileURL = window.URL.createObjectURL(blob);
    
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = 'receipt.pdf';
            alink.click();
            showLoader(false)
        })
    })
}


  const fetchData = () => {
    instance
      .get("/cust_receipt?id=" + id)
      .then(function (response) {

        setState({ ...state, ...response.data });

      })
      .catch(function (error) { })
      .then(function () { });

  }

  useEffect(() => {
    setTitle('Receipt')
    fetchData()
  }, []);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }


  return (
    <div className="mt-2">
      <Helmet>
        <title>Receipt</title>
        {pstate.company && pstate.company.logo  &&  <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>
      {state.status ? (
        <>
        <div className="card card-default mb-3">
          <div className="card-body">
            <ReceiptTemplate data={state.receipt} />
          </div>
          </div>
          <UiButton className="btn btn-primary" onClick={()=>downloadPdf(state.receipt.id,state.receipt.receipt_id)} loading={loader} title="Download Receipt"></UiButton>
          </>)
        : <BgLoader />}

    </div>
  );
}
